import React from "react";

const Icon4 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="76"
      viewBox="0 0 68 76"
      fill="none"
    >
      <path
        d="M1 1H17.4444V70.8889H25.6667V1H66.7778V75H50.3333V5.11111H42.1111V75H1V1Z"
        stroke="#020208"
        strokeWidth="1.5"
        className="svg-elem-1"
      ></path>
    </svg>
  );
};

export default Icon4;
